"use strict";

angular.module("customer")
.component("invoiceListing", {
    templateUrl: require("./invoice-listing.component.html"),
    controllerAs: "invoiceListingCtrl",
    bindings: {
        dedicatedVendorId: "<",
        isPaid: "<?",
        showFilterDue: "<?",
        showPaymentButton: "<?"
    },
    controller: function(
        $scope, $state, $stateParams, InvoiceService, InvoiceStatusService, StateExtensionService
    ) {
        $scope.pagination = {};
        $scope.params = angular.extend({}, $stateParams);
        $scope.filterStatusService = InvoiceStatusService;
        $scope.statusNamesLocalized = $scope.filterStatusService.getStatusNamesLocalized();
        $scope.selectedVendor = null;

        $scope.DUE_DATE_FILTER_ALL = 'all';
        $scope.DUE_DATE_FILTER_OVERDUE = 'overdue';
        $scope.DUE_DATE_FILTER_0_7D = '0_7d';
        $scope.DUE_DATE_FILTER_8_15D = '8_15d';
        $scope.DUE_DATE_FILTER_16D = '16d';

        var startOfDay = moment().startOf('day');
        var endOfDay = moment().endOf('day');

        $scope.paymentDueDateFilters = {}
        $scope.paymentDueDateFilters[$scope.DUE_DATE_FILTER_ALL] = {
            payment_due_date_start: undefined,
            payment_due_date_end: undefined
        };
        $scope.paymentDueDateFilters[$scope.DUE_DATE_FILTER_OVERDUE] = {
            payment_due_date_start: undefined,
            payment_due_date_end: moment().toISOString()
        };
        $scope.paymentDueDateFilters[$scope.DUE_DATE_FILTER_0_7D] = {
            payment_due_date_start: moment().toISOString(),
            payment_due_date_end: moment(endOfDay).add(7, "days").toISOString()
        };
        $scope.paymentDueDateFilters[$scope.DUE_DATE_FILTER_8_15D] = {
            payment_due_date_start: moment(startOfDay).add(8, "days").toISOString(),
            payment_due_date_end: moment(endOfDay).add(15, "days").toISOString()
        };
        $scope.paymentDueDateFilters[$scope.DUE_DATE_FILTER_16D] = {
            payment_due_date_start: moment(startOfDay).add(16, "days").toISOString(),
            payment_due_date_end: undefined
        };

        function query() {
            InvoiceService.query($scope.params).$promise
            .then(function onSuccess(data) {
                $scope.pagination = data.pagination;
                $scope.invoices = data.results;
                StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
            });
        }

        this.onPageChanged = function() {
            $scope.params = angular.extend($scope.params, {
                page: $scope.pagination.current_page
            });
            query();
        };

        this.seeDetails = function(id) {
            $state.go("invoiceDetails", {id: id});
        };

        this.filterByPaymentOverdueDate = function(filter) {
            if ($scope.selectedPaymentDueDateFilter === filter) {
                return;
            }
            $scope.selectedPaymentDueDateFilter = filter;
            angular.extend($scope.params, {payment_due_filter: $scope.selectedPaymentDueDateFilter});
            angular.extend($scope.params, $scope.paymentDueDateFilters[$scope.selectedPaymentDueDateFilter]);
            StateExtensionService.updateUrlParams($scope.params);
            query();
        };

        this.isPaymentOverdueDateFilterActive = function(filter) {
            return $scope.selectedPaymentDueDateFilter === filter;
        };

        $scope.$on("listingFilterUpdated", function() {
            angular.extend($scope.params, {payment_due_filter: $scope.selectedPaymentDueDateFilter});
        });

        $scope.$on("doResetListing", function(event, selectedVendor) {
            $scope.selectedVendor = selectedVendor;
            $scope.pagination.current_page = 1;
            var vendorId = null;
            if (selectedVendor && selectedVendor.vendor_id) {
                vendorId = selectedVendor.vendor_id;
            }
            angular.extend($scope.params, $stateParams);
            angular.extend($scope.params, {vendor: vendorId});
            StateExtensionService.updateUrlParams($scope.params);
            $scope.selectedPaymentDueDateFilter = $stateParams.payment_due_filter;
            query();
        });

        $scope.$emit('invoiceListingReady');
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/invoice-listing/invoice-listing.component.js
// module id = 873
// module chunks = 0